import { createMuiTheme, makeStyles } from "@material-ui/core/styles";
import { appConfig } from "./config";

const theme = {
  //https://material-ui.com/customization/default-theme/?expand-path=$.palette
  palette: {
    primary: {
      main: appConfig.color1,
      contrastText: "#fff"
    },
    secondary: { main: appConfig.color2 },
    contrastThreshold: 3
  },
  typography: {
    fontSize: 14,
    body1: {
      fontSize: 14,
      fontFamily: '"Open Sans","sans-serif"'
    },
    h6: {
      fontFamily: '"Oswald","sans-serif"'
    }
  },
  shape: {
    buttonBorderRadius: "20px",
    paperBorderRadius: "4px"
    // other shape properties...
  },
  overrides: {
    MuiButton: {
      root: {
        fontFamily: "Oswald",
        height: "37px"
      },
      sizeLarge: {
        height: "50px"
      }
    },
    MuiCardHeader: {
      title: {
        fontFamily: '"Oswald","sans-serif"'
      }
    },
    MuiDialogTitle: {
      root: {
        color: appConfig.color1
      }
    },
    MuiDialogContent: {
      root: {
        backgroundColor: "#F3f3f3",
        padding: "1rem"
      }
    },
    MuiDialogActions: {
      root: {
        padding: "1rem"
      }
    },
    MuiIconButton: {
      label: {
        "&:hover": {
          color: appConfig.color1
        }
      }
    },
    MuiFormLabel: {
      root: {
        fontSize: 14
      }
    },
    MuiInputBase: {
      root: {
        background: "#fff",
        fontSize: 14
      }
    },
    MuiPaper: {
      root: {
        padding: "0rem"
      }
    },
    MuiSelect: {
      root: {
        "label + &": {
          marginTop: "1rem"
        }
      },
      input: {
        borderRadius: 4,
        position: "relative",
        border: "1px solid #ced4da",
        fontSize: 16,
        width: "auto",
        padding: "10px 26px 10px 12px"
      }
    }
  },
  props: {
    MuiButton: {
      color: "primary",
      variant: "contained",
      size: "medium"
    },
    MuiCheckbox: {
      color: "primary",
      size: "medium"
    },
    MuiIconButton: {},
    MuiSelect: {
      size: "small",
      margin: "dense",
      variant: "outlined"
    },
    MuiTextField: {
      variant: "outlined",
      size: "small",
      margin: "dense"
    }
  }
};

export const useStyles = makeStyles({
  surveyItem: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "spaceBetween"
  },
  surveyItemHeader: {
    flex: "1 1",
    alignItems: "flexStart",
    cursor: "pointer"
  },
  surveyItemContent: {
    background: "#f3f3f3",
    flex: "1 1",
    cursor: "pointer"
  },
  surveyItemActions: {
    display: "flex",
    justifyContent: "space-between",
    flex: "0 1"
  },
  navButtonLabel: {
    justifyContent: "flex-start"
  },
  navButtonStartIcon: {
    marginLeft: "0px"
  }
});

export default createMuiTheme(theme);
